import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { ApiUrls, Doctypes } from 'src/app/shared/api-urls';
import { environment } from 'src/environments/environment';
import * as Moment from 'moment';
import DataTable from "frappe-datatable";
// import { PosReportsFiltersPipe } from './../../../shared/pipes/pos-reports-filters.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from './../../../shared/services/storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'; import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

class InvoicesFilter {
  // itemsPerPage = 20;
  // currentPage = 1;
  // totalCount = 0;
  // start = 0
  // active = 2;
  selectedReport = 'ENT';
  selectedDoctpe = 'Transaction Summary';
  // default_Date = 'This Week';
  // from_date = '';
  // to_date = '';
  // custom = '';
  reportType = 'Ent Report';
  file_upload_date: any = new Date()
  timePeriod = 'Check Duration Report'
  search = {
    outlet: '',
    check_found: ''
  };

}
@Component({
  selector: 'app-pos-reports',
  templateUrl: './pos-reports.component.html',
  styleUrls: ['./pos-reports.component.scss']
})
export class PosReportsComponent implements OnInit {

  @ViewChild('excelUpload') excelUpload: ElementRef;
  filterValue: string = '';
  filters = new InvoicesFilter();
  onSearch = new EventEmitter();
  searchType = '';
  searchText = '';
  check_found = 'Yes';
  doctypedata: any = [];
  selectedDate: string;
  companyDetails: any = {};
  minDate: string = '1000-01-01'; // min year allowed
  maxDate: string = '9999-12-31'; // max year allowed
  // apiDomain = environment.apiDomain;
  uploadProgress = {
    status: 'NO',
    progress: 0,
    label: 'Uploading',
    color: "secondary",
    data: null
  }
  colList = [];
  valueList = [];
  colListXL = []
  loggedInUser;
  company
  domain: any = environment.apiDomain;
  reportTypeList = [];
  uploaded_files: any = {
    transaction_file: '',
    transaction_file_url: '',
    closed_checks: '',
    closed_checks_url: '',
    void_checks: '',
    void_checks_url: '',
    discount_checks: '',
    discount_checks_url: ''
  }
  transactionFileSuccess: boolean = false;
  discountFileSuccess: boolean = false;
  voidFileSuccess: boolean = false;
  closedFileSuccess: boolean = false;
  constructor(private http: HttpClient,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute, private storage: StorageService,
    private router: Router, private modal: NgbModal,) {
    const today = new Date();
    this.selectedDate = today.toISOString().substring(0, 10);
    // this.selectedDate = Moment().format('DDMMYYYY');
  }

  ngOnInit(): void {

    this.companyDetails = JSON.parse(localStorage.getItem('company'));
    this.getReportsTypes('count');
    // this.activatedRoute.queryParams.subscribe((res: any) => {
    //  console.log(res,'==============')
    //   if (res.search) {
    //     const dateBy = JSON.parse(res.search)
    //     this.filters.search.outlet = dateBy.outlet;
    //     this.filters.search.check_found = res.check_found;
    //   }
    // })
  }


  updateRouterParams(): void {
    const temp = JSON.parse(JSON.stringify(this.filters));
    temp.search = JSON.stringify(temp.search);
    this.router.navigate(['home/pos-reports'], {
      queryParams: temp
    });
  }


  uploadExcelFile(data: any) {

    const modal = this.modal.open(this.excelUpload, {

      centered: true, size: 'lg', backdrop: 'static'

    })
    modal.result.then((res: any) => {
      if (res == 'refresh') {
      }
    })
  }
  async uploadExcels(invoiceInp: HTMLInputElement, gstInp: HTMLInputElement) {

    const upload = async (file: File) => {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('is_private', '1');
        formData.append('folder', 'Home');
        formData.append('doctype', Doctypes.invoices);
        formData.append('docname', 'Manual-Upload-' + Moment(new Date()).format('YYYY/MM/DD'));

        this.http.post(ApiUrls.uploadFile, formData).subscribe(
          (res: any) => {

            resolve(res.message?.file_url);

          }, (err) => {
            resolve(0);
          }, () => {
          });
      });
    }
    /** getting uploaded invoice urls */
    let invoiceUrl, gstUrl;
    if (invoiceInp.files[0]) {
      invoiceUrl = await upload(invoiceInp.files[0]);
    }
    if (gstInp?.files[0]) {
      gstUrl = await upload(gstInp.files[0]);
    }


  }


  handleFileInput(files: File[], type: any) {
    let fileToUpload = files[0];
    let doctype_type;

    if (type == 'transaction') doctype_type = 'Transaction Summary'

    if (type == 'closed') doctype_type = 'Closed Checks'

    if (type == 'void') doctype_type = 'Void Checks'

    if (type == 'discount') doctype_type = 'Discount Checks'


    if (fileToUpload) {
      const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);
      formData.append('is_private', '1');
      formData.append('folder', 'Home');
      // formData.append('doctype', doctype_type);
      // formData.append('fieldname', 'attachment');
      // formData.append('docname', this.companyDetails.company_code);
      this.http.post(ApiUrls.uploadFile, formData).subscribe((res: any) => {
        // console.log(res, '----------')
        if (res.message.file_url) {
          let file_url = res.message.file_url
          if (type == 'transaction') {
            this.uploaded_files.transaction_file_url = file_url;
            // this.trasaction_file()
          }
          if (type == 'closed') {
            this.uploaded_files.closed_checks_url = file_url
            // this.closed_file()
          }
          if (type == 'void') {
            this.uploaded_files.void_checks_url = file_url
            // this.void_file()
          }
          if (type == 'discount') {
            this.uploaded_files.discount_checks_url = file_url
            // this.discount_file()
          }

        }
      })
    }


  }


  closeModal() {
    this.modal.dismissAll();
  }

  trasaction_file() {
    this.http.post(ApiUrls.transaction_summary_extraction, {
      file: this.uploaded_files.transaction_file_url,
      period: this.selectedDate
    }).toPromise()
      .then((res: any) => {
        // console.log(res)
        if (res?.message?.success) {
          this.toastr.success(res?.message?.message);
          this.transactionFileSuccess = true;
        } else {
          this.toastr.error(res?.message?.message);
          this.transactionFileSuccess = false;
        }
      })

  }


  discount_file() {
    this.http.post(ApiUrls.discount_file_extraction, {
      discount_file: this.uploaded_files.discount_checks_url,
      period: this.selectedDate
    }).toPromise()
      .then((res: any) => {
        // console.log(res)
        if (res?.message?.success) {
          this.toastr.success(res?.message?.message);
          this.discountFileSuccess = true;
        } else {
          this.toastr.error(res?.message?.message);
          this.discountFileSuccess = false;
        }
      })
  }
  void_file() {
    this.http.post(ApiUrls.void_file_extraction, {
      void_file: this.uploaded_files.void_checks_url,
      period: this.selectedDate
    }).toPromise()
      .then((res: any) => {
        // console.log(res)
        if (res?.message?.success) {
          this.toastr.success(res?.message?.message);
          this.voidFileSuccess = true;
        } else {
          this.toastr.error(res?.message?.message);
          this.voidFileSuccess = false;
        }
      })
  }
  closed_file() {
    this.http.post(ApiUrls.closed_file_extraction, {
      closed_file: this.uploaded_files.closed_checks_url,
      period: this.selectedDate
    }).toPromise()
      .then((res: any) => {
        // console.log(res)
        if (res?.message?.success) {
          this.toastr.success(res?.message?.message);
          this.closedFileSuccess = true;
        } else {
          this.toastr.error(res?.message?.message);
          this.closedFileSuccess = false;
        }
      })
  }

  submit_all_files() {
    this.http.post(ApiUrls.reconcilling_check_details, {
          trans_summary: this.uploaded_files.transaction_file_url,
        closed_tender: this.uploaded_files.closed_checks_url,
        void: this.uploaded_files.void_checks_url,
        discount: this.uploaded_files.discount_checks_url,
        period: this.selectedDate
    }).subscribe((res: any) => {
      if (res?.message?.success) {
        this.toastr.success(res.message.message)
        this.closeModal();
      }
      else {
        this.toastr.error(res.message.message)
      }
    })

   
  }

  // submit_all_files() {
  //   if (this.transactionFileSuccess && this.discountFileSuccess && this.voidFileSuccess && this.closedFileSuccess) {
  //     this.http.post(ApiUrls.reconcilling_check_details, {
  //       trans_summary: this.uploaded_files.transaction_file_url,
  //       closed_tender: this.uploaded_files.closed_checks_url,
  //       void: this.uploaded_files.void_checks_url,
  //       discount: this.uploaded_files.discount_checks_url,
  //       period: this.selectedDate
  //     }).subscribe((res: any) => {
  //       if (res?.message?.success) {
  //         this.toastr.success(res.message.message);
  //       } else {
  //         this.toastr.error(res.message.message);
  //       }
  //     });
  //     this.closeModal();
  //   } else {
  //     this.toastr.error('Please upload all required files.');
  //   }
  // }


  export_report() {

    let apiUrl;
    if (this.filters.selectedReport == 'ENT' || this.filters.selectedReport == 'HDC' || this.filters.selectedReport == 'OWN' || this.filters.selectedReport == 'OC') {
      apiUrl = ApiUrls.print_ent_format;
    } else if (this.filters.selectedReport == 'discount' || this.filters.selectedReport == 'Check duration') {
      apiUrl = ApiUrls.print_discount_format
    } else {
      apiUrl = ApiUrls.print_formt_void_check
    }
    this.http.get(ApiUrls.pos_reports_export, {
      params: {
        name: this.filters.reportType,
        date: Moment(this.selectedDate).format("DD/MM/YYYY")
      }
    }).subscribe((res: any) => {
      if (res?.message?.success) {
        window.open(`${this.domain}${res?.message?.file_urls}`, "_blank")
      } else {
        this.toastr.error(res?.message?.message)
      }
    })
  }


  getReportsTypes(count): void {
    const params: any = {
      filters: JSON.stringify([["Report", "ref_doctype", "in", [Doctypes.checkDetails]], ["Report", "disabled", "=", 0]])

    };
    params["page_length"] = count;
    params["order_by"] = "`tabReport`.`creation` asc";

    this.http.get(ApiUrls.reportList, { params: params }).subscribe((res: any) => {
      this.reportTypeList = res?.data
    })
  }
  getActivatedParamsData(): void {
    this.colListXL = []
    this.valueList = []
    this.colList = []
    // let tableId = document.querySelector('#datatable');
    this.activatedRoute.queryParams.pipe(switchMap((params: InvoicesFilter) => {

      if (this.filters.search.outlet) {
        this.searchText = this.filters.search.outlet;
        this.searchType = 'outlet'
      }
      if (this.filters.search.check_found) {
        this.check_found = this.filters.search.check_found;
      }
      this.filters.reportType = this.filters.reportType || params.reportType;
      let filtersParams = {
        report_name: this.filters.reportType,

      }

      if (this.filters.reportType === 'Check Duration Report') {

        filtersParams['filters'] = JSON.stringify({ business_period: Moment(this.selectedDate).format("DD/MM/YYYY") });
        if (this.filters?.timePeriod === 'lessthan20mins') {
          // console.log('============0000000', this.filters.timePeriod)
          filtersParams['filters'] = JSON.stringify({
            business_period: Moment(this.selectedDate).format("DD/MM/YYYY"),
            check_duration: 'less_than_20_mins'
          });
        } else if (this.filters?.timePeriod === 'morethan2hours') {
          // console.log('============0000000', this.filters.timePeriod)
          filtersParams['filters'] = JSON.stringify({
            business_period: Moment(this.selectedDate).format("DD/MM/YYYY"),
            check_duration: 'greater_than_2_hours'
          });
        }
      } else {
        filtersParams['filters'] = JSON.stringify({ business_period: Moment(this.selectedDate).format("DD/MM/YYYY") });
      }
      // console.log(filtersParams.report_name)
      // filtersParams['filters'] = JSON.stringify({ business_period: Moment(this.selectedDate).format("DD/MM/YYYY") })


      const resultApi = this.http.get(ApiUrls.reports, {
        params: filtersParams
      });
      return resultApi;
    })).subscribe((res: any) => {
      if (res?.message?.columns) {
        this.colListXL = res?.message?.columns.map(item => item.label)
        this.valueList = res?.message?.result.map(item => Object.values(item))

        // console.log(" col List XL  === ", this.colListXL)
        // console.log(" ==== vale List ===== ", this.valueList)

        this.colList = res?.message?.columns.map(item => {
          let obj = {};
          obj['name'] = item?.label
          obj['width'] = 170
          return obj;
        })
      } else {
        // console.log("===============")
      }
    })

  }
  onreportTypeChange(event) {
    this.getActivatedParamsData()
    // this.updateRouterParams()
  }

  handleDateChange() {
    // You can perform any additional actions here when the selected date changes
    // console.log('Selected date:', this.selectedDate);
    this.getActivatedParamsData()
    if (this.selectedDate < this.minDate || this.selectedDate > this.maxDate) {
      this.selectedDate = '';
    }
    // this.selectedDate = Moment( this.selectedDate.format("DDMMYYYY"))

  }
  updateFilter(value) {
    this.getActivatedParamsData();
    // this.updateRouterParams()
  }
  viewFile(filePath: string): void {
    // console.log(filePath)
    window.open(`${this.domain}${filePath}`, "_blank")
  }
  onKeyDown(event: KeyboardEvent) {
    // console.log(event)
    event.preventDefault(); // Prevents the default behavior of keyboard events
  }
  openDatePicker(event?: Event) {
    // console.log(event)
    const inputField = document.getElementById('selectedDate') as HTMLInputElement;
    inputField.click();
  }

}
